landing = document.querySelector(".v_transparent");
if (landing) {
  window.addEventListener("load", () => {
    document.querySelector(".v_transparent").classList.add("v_visible");
  });
}
